/* __next_internal_client_entry_do_not_use__ VerticalExpandingTiles auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { handleGenerateBrandUrl, handleGenerateProductLinkProps } from "@faire/retailer-visitor-shared/components/Carousel/utils";
import { getTokensForViewEvent } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { MarketplaceProduct } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/MarketplaceProduct";
import { ILeanProductWithBrandTile } from "@faire/retailer-visitor-shared/lib/ILeanProductWithBrandTile";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/Arrow";
import { Grid } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
export var VerticalExpandingTiles = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var location = useLocation();
    var _useState = _sliced_to_array(useState(0), 2), currentExpansion = _useState[0], setCurrentExpansion = _useState[1];
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId, onItemClick = _React_useContext.onItemClick, onVisible = _React_useContext.onVisible, onCTAClick = _React_useContext.onCTAClick;
    var rowsPerState = useResponsiveValue({
        mobileAndAbove: 4,
        tabletAndAbove: 2
    });
    var itemsPerRow = useResponsiveValue({
        mobileAndAbove: 2,
        tabletAndAbove: 4,
        desktopAndAbove: 5
    });
    var itemsPerState = rowsPerState * itemsPerRow;
    var items = layoutElement.layout_element_data.filter(isNotUndefined);
    var maxExpansions = Math.min(Math.floor((items.length - 1) / itemsPerState), 2);
    var handleOnProductClick = function(product) {
        return function() {
            var _layoutElement_on_click_event_name, _product_token;
            onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, (_product_token = product === null || product === void 0 ? void 0 : product.token) !== null && _product_token !== void 0 ? _product_token : "");
        };
    };
    var handleOnBrandClick = function(brand) {
        return function() {
            var _layoutElement_on_click_event_name, _brand_token;
            onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, (_brand_token = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token !== void 0 ? _brand_token : "");
        };
    };
    var handleComponentVisible = useCallback(function(start) {
        var _getTokensForViewEvent;
        var items = (_getTokensForViewEvent = getTokensForViewEvent(layoutElement, strictLocalize)) === null || _getTokensForViewEvent === void 0 ? void 0 : _getTokensForViewEvent.slice(start, start + itemsPerState);
        if (layoutElement.on_click_event_name) {
            var _items_join;
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, (_items_join = items === null || items === void 0 ? void 0 : items.join(" ")) !== null && _items_join !== void 0 ? _items_join : "");
        }
    }, [
        itemsPerState,
        layoutElement,
        onVisible,
        requestId,
        strictLocalize
    ]);
    var handleClickSeeMore = useCallback(function() {
        var _layoutElement_on_click_event_name;
        onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId);
        handleComponentVisible(itemsPerState * (currentExpansion + 1));
        setCurrentExpansion(currentExpansion + 1);
    }, [
        currentExpansion,
        handleComponentVisible,
        itemsPerState,
        layoutElement.on_click_event_name,
        onCTAClick,
        requestId
    ]);
    var renderItem = function(data) {
        var _tile_brand, _tile_product_product, _tile_product, _tile_product1, _tile_product_product1, _tile_product2;
        var tile = ILeanProductWithBrandTile.fromLayoutElementData(data, strictLocalize);
        return tile ? /*#__PURE__*/ _jsx(MarketplaceProduct, {
            recordAdImpression: true,
            productTile: tile.product,
            brand: tile.brand,
            generateProductLinkProps: handleGenerateProductLinkProps(tile.product, location),
            generateBrandUrl: handleGenerateBrandUrl((_tile_brand = tile.brand) === null || _tile_brand === void 0 ? void 0 : _tile_brand.token, (_tile_product = tile.product) === null || _tile_product === void 0 ? void 0 : (_tile_product_product = _tile_product.product) === null || _tile_product_product === void 0 ? void 0 : _tile_product_product.token),
            onClick: handleOnProductClick((_tile_product1 = tile.product) === null || _tile_product1 === void 0 ? void 0 : _tile_product1.product),
            onBrandClick: handleOnBrandClick(tile.brand),
            showVerticalImagery: layoutElement.show_vertical_imagery
        }, (_tile_product2 = tile.product) === null || _tile_product2 === void 0 ? void 0 : (_tile_product_product1 = _tile_product2.product) === null || _tile_product_product1 === void 0 ? void 0 : _tile_product_product1.token) : null;
    };
    var viewRef = useDoActionWhenVisible(function() {
        return handleComponentVisible(itemsPerState * currentExpansion);
    });
    return items.length >= 5 ? /*#__PURE__*/ _jsxs(GridWrapper, {
        ref: viewRef,
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                columns: itemsPerRow,
                columnGap: {
                    mobileAndAbove: "1x",
                    desktopAndAbove: "2x"
                },
                rowGap: {
                    mobileAndAbove: "3x",
                    desktopAndAbove: "4x"
                },
                columnTemplate: function(columns) {
                    return "repeat(".concat(columns, ", minmax(0,1fr));");
                },
                children: items.slice(0, (currentExpansion + 1) * itemsPerState).map(renderItem)
            }),
            currentExpansion < maxExpansions ? /*#__PURE__*/ _jsx(ButtonContentWrapper, {
                children: /*#__PURE__*/ _jsxs(StyledButton, {
                    variant: "tertiary",
                    onClick: handleClickSeeMore,
                    children: [
                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "Xad1K8",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Show more"
                                }
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Arrow, {
                            direction: "down",
                            fontSize: "12px"
                        })
                    ]
                })
            }) : null
        ]
    }) : null;
};
var ButtonContentWrapper = styled.div.withConfig({
    componentId: "sc-af4d0c6b-0"
})([
    "width:100%;text-align:center;display:flex;justify-content:center;padding-top:",
    ";",
    "{padding-top:",
    ";}"
], getSpacing("5x"), responsiveMediaQueries.mobile, getSpacing("2x"));
var StyledButton = styled(Button).withConfig({
    componentId: "sc-af4d0c6b-1"
})([
    "",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
var GridWrapper = styled.div.withConfig({
    componentId: "sc-af4d0c6b-2"
})([
    "",
    "{padding:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(0, "2x"));
